import { useEffect } from 'react';
import { Canvas } from 'fabric';
import { isMacLike, isTextField } from '../../shared/utils/keyboard-platform';
import { useGrouping } from './use-grouping';

type Transaction = (fn: () => void | Promise<void>) => Promise<void> | void;

/** ⌘/Ctrl+G to group, ⌘/Ctrl+Shift+G to ungroup. */
export const useGroupingShortcuts = (canvas: Canvas | null, transaction?: Transaction): void => {
  const { canGroup, canUngroup, groupSelection, ungroupSelection } = useGrouping(canvas, transaction);

  useEffect(() => {
    const handle = (e: KeyboardEvent) => {
      if (isTextField(e.target)) return;
      const mod = isMacLike() ? e.metaKey : e.ctrlKey;
      if (!mod) return;
      if (e.key.toLowerCase() !== 'g') return;

      if (e.shiftKey) {
        if (!canUngroup) return;
        e.preventDefault();
        ungroupSelection();
      } else {
        if (!canGroup) return;
        e.preventDefault();
        groupSelection();
      }
    };

    window.addEventListener('keydown', handle);
    return () => window.removeEventListener('keydown', handle);
  }, [canGroup, canUngroup, groupSelection, ungroupSelection]);
};
